import { render, staticRenderFns } from "./DeliveryTypeSelect.vue?vue&type=template&id=ea0c87ea"
import script from "./DeliveryTypeSelect.vue?vue&type=script&lang=ts"
export * from "./DeliveryTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports